export const zIndexes = {
  // MODAL: 103, (this is the zIndex for cd2 comps and is just here for a reference)
  HOVER_LOADER: 104,
  STOCK_LOOKUP_SEARCHING: 100,
}
